import {NpsTranslation} from "../interfaces/NpsTranslationData";
import {OptionProp} from "../../../components/SelectGroup/interfaces/OptionProp";

export const getReasons = (translate: NpsTranslation | undefined): OptionProp[] => {
    if (!translate) return [{id: 0, option: ''}]
    return [
        {
            id: 1,
            option: translate.Option1
        },
        {
            id: 2,
            option: translate.Option2
        },
        {
            id: 3,
            option: translate.Option3
        },
        {
            id: 4,
            option: translate.Option4
        },
        {
            id: 5,
            option: translate.Option5
        }
    ]
}